<template>
  <h2 :style="{color:color,'max-width':maxWidth}">{{ title }}</h2>
</template>

<script>
export default {
  name: 'LandingTitle',
  props: {
    title: {
      type: String,
      required: true,
    },
    color: {
      type: String,
      required: true,
    },
    maxWidth: {
      type: String,
      default: 'initial',
    },
  },
};
</script>

<style
  scoped
  lang="scss"
>
@import "~@/assets/scss/mixins";

h2 {
  margin: 0 auto 32px auto;

  font-size: 24px;
  line-height: 32px;
  font-weight: 700;
  text-align: center;

  @include media-lg() {
    margin: 0 auto 64px auto;

    font-size: 40px;
    line-height: 40px;
  }
}

</style>
